<template>
	<hr class="Divider" :class="classes" />
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {
		classes() {
			return {
				'Divider--reverse': this.reverse,
				'Divider--light': this.light,
				'Divider--flush': this.flush,
				'Divider--sm': this.size === 'sm',
				'Divider--lg': this.size === 'lg',
			};
		},
	},
	props: {
		/**
		 * color for dark backgrounds
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * lighter color
		 */
		light: {
			type: Boolean,
			default: false,
		},
		/**
		 * no top or bottom margin
		 */
		flush: {
			type: Boolean,
			default: false,
		},
		/**
		 * size of top and bottom margin
		 */
		size: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss">
.Divider {
	box-sizing: content-box;
	height: 0;
	border: 1px solid $color-line;
	border-right: 0;
	border-top: 0;
	border-left: 0;
	margin: $space-md 0;
}

.Divider--light {
	border-color: subdueColor($brand-color-sand-10);
}

.Divider--reverse {
	border-color: $color-line-reverse;
}

.Divider--flush {
	margin: 0;
}

.Divider--sm {
	margin: $space-sm 0;
}

.Divider--lg {
	margin: $space-lg 0;
}
</style>
